import React, { useState } from "react";
import PlantillasTelegramList from "./PlantillasTelegramList";
import LoadSimple from "../../../LoadSimple";
import { capitalizeFirstLetter } from "../../../../utils/utils";
import { lang } from "../../../generales/traduction";

const TablePlantillasTelegram = ({
  pageActual,
  limitList,startLimit,
  devices,
  dataList,
  cisSelected,
  setCisSelected,
  registerIsValid,
  searchResults,
  setSearchResults,
  onSearch,
  dataUsers,
  setDataUsers,
  searchTerm,
  setSearchTerm,
  server,
  setRegisterIsValid,
  setData,
  setLoading,
  setError,
  handleChangEdit,
  languaje,
  mode,
  setContRowSelected,
  poolRows,setPoolRows,
  handleShowPopup,
  buscar_cis,
  loadingList
}) => {
  const [allSelected, setAllSelected] = useState(false);
  setContRowSelected(poolRows.length)
  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }
    setPoolRows((prevRows) => {
      // Busca si el dispId ya existe en el array
      const exists = prevRows.includes(elemento.id);
      
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(id => id !== elemento.id);
      } else {
        return [...prevRows, elemento.id];
      }
    });
  };
  const handleSelectAll = () => {
    if (allSelected) {
      // Si ya está todo seleccionado, deselecciona todo
      setPoolRows([]);
    } else {
      // Si no, selecciona todos los elementos
      // setPoolRows(dataList
      //   .slice(startLimit, parseInt(pageActual) * parseInt(limitList)));
        // setPoolRows(dataList);
        setPoolRows(dataList.map(item => item.id))
    }
    setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
  };
  return (
    <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
      {/* <div className="field-head-table-mantenimiento field-small">  <div className='cont-checkbox'>
                 <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}}  onClick={()=>handleSelectAll()} ></input>
                </div></div> */}
        <div className="field-head-table-mantenimiento field-small" > {'ID'}</div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'16%'}}>{capitalizeFirstLetter(lang[languaje]['comando'])}</div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'40%'}}>{capitalizeFirstLetter(lang[languaje]['descripcion'])}</div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'25%'}}>{capitalizeFirstLetter(lang[languaje]['layout'])} </div>
        <div className="field-head-table-mantenimiento field-larger" style={{width:'16%'}}>{capitalizeFirstLetter(lang[languaje]['vars'])}</div>
        
        </div>
        
      </div>
      <div className="body-table-portafolio">
        {registerIsValid ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          <PlantillasTelegramList
            pageActual={pageActual}
             limitList={limitList} startLimit={startLimit}
            dataList={dataList}
            devices={devices}
            cisSelected={cisSelected}
            setCisSelected={setCisSelected}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            dataUsers={dataUsers}
            setDataUsers={setDataUsers}
            server={server}
            setRegisterIsValid={setRegisterIsValid}
            setData={setData}
            setLoading={setLoading}
            setError={setError}
            handleChangEdit={handleChangEdit}
            languaje={languaje}
            mode={mode}
            setContRowSelected={setContRowSelected}
            rowSelected={rowSelected}
            poolRows={poolRows}
            handleShowPopup={handleShowPopup}
            buscar_cis={buscar_cis}
            loadingList={loadingList}
          ></PlantillasTelegramList>
        )}
      </div>
    </div>
  );
};

export default TablePlantillasTelegram;
